module.exports = __webpack_public_path__ + "static/media/17.07360ce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/17.png
// module id = 1347
// module chunks = 0